import { FormattedMessage } from 'react-intl';
import { FormikPoolDatePicker } from '@synergy/components-next';
import { PaloField } from '@synergy/components-palo';
import { useFormikContext } from 'formik';

import { FunctionalAssetAutocomplete } from '../../../../../../common/components/functional-asset-autocomplete/functional-asset-autocomplete';
import { OverviewFormValues, overviewFieldNames } from '../../../models/overview-form-values';
import { PaloTextControl } from '../../../../../../common/components/palo/palo-text-control';

interface PaloInvoiceHeadOrderProps {
    readonly?: boolean;
}

/** What the member ordered under: cost centre, asset, reference and date. */
export const PaloInvoiceHeadOrder = ({ readonly }: PaloInvoiceHeadOrderProps) => {
    const { values } = useFormikContext<OverviewFormValues>();

    return (
        <>
            <PaloTextControl
                name={overviewFieldNames.costCentre}
                label={<FormattedMessage id="app.label.costCentre" />}
                area="costCentre"
                disabled={readonly}
            />
            <PaloField label={<FormattedMessage id="app.label.functionalAsset" />} area="functionalAsset">
                <FunctionalAssetAutocomplete
                    name={overviewFieldNames.functionalAsset}
                    label={<></>}
                    supplierId={values.supplierAccount?.id}
                    customerId={values.recipientAccount?.id}
                    required={false}
                    disabled={readonly}
                />
            </PaloField>
            <PaloTextControl
                name={overviewFieldNames.orderReference}
                label={<FormattedMessage id="app.label.orderReference" />}
                area="orderReference"
                disabled={readonly}
            />
            <PaloField label={<FormattedMessage id="app.label.orderDate" />} area="orderDate">
                <FormikPoolDatePicker name={overviewFieldNames.orderDate} readOnly={readonly} setTimeToMidday={true} />
            </PaloField>
        </>
    );
};
